import * as React from "react"

import { CommonFilters } from "@components"
import { COMMON_FILTER_KEYS } from "@constants"


export default function CommonFiltersMarketplaces({ components={}, userFilters, isLoadingDefaultFilters, ...props }) {
    return <CommonFilters
		components={{
			buyBox: true, authorizedSeller: true,
			withShippingPrice: true,
			country: true, site: true,
			category: true, brand: true,
			sku: true, favFilters: true,
			skuGroup: true, ...components
		}}
		compProps={{
			withShippingPrice: { grid: { xs: 5 } },
			country: { filters: { websiteType: "2" } },
			site: { filters: { websiteType: "2" } },
			favFilters: {
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.SPLIT_KPI, COMMON_FILTER_KEYS.BUY_BOX,
					COMMON_FILTER_KEYS.AUTHORIZED_SELLER, COMMON_FILTER_KEYS.INCLUDE_SHIPPING_PRICE
				]
			}
		}}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
		{...props}
	/>
}